import { SUBSCRIPTIONS_CUSTOMER_CONTROLLER_ROOT_PATH } from "../root";

/** /customer/subscription/fresh */
export const SUBSCRIPTIONS_CUSTOMER_FRESH_CONTROLLER_ROOT_PATH = `${
  SUBSCRIPTIONS_CUSTOMER_CONTROLLER_ROOT_PATH
}/fresh`;
